import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaOrganiSensoEditComponent.vue?vue&type=template&id=0bb2f722"
import script from "./RsaSchedaRelazioneSanitariaOrganiSensoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaOrganiSensoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports